// extracted by mini-css-extract-plugin
module.exports = {"fb-share-button":"_3gAPmarHLKHIWRfbb6BnSC","fb-logo":"frEKfWBBRtF2-8IP-A928","fb-share-text":"pW6xsAyncCOz9FRQJiQQi"};